import Header from '../components/Header';
import Hero from '../components/Hero';
import StorySection from '../components/StorySection';
import ImpactStats from '../components/ImpactStats';
import CommunityInMotion from '../components/CommunityInMotion';
import Programs from '../components/Programs';
import Testimonials from '../components/Testimonials';
import Events from '../components/Events';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
// Newsletter component kept in repo but not rendered until an email service is chosen.
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { useI18n } from '../contexts/I18nContext';

export default function Home() {
  const { t } = useI18n();
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [1, 2, 3, 4, 5].map((n) => ({
      '@type': 'Question',
      name: t(`faq.q${n}`),
      acceptedAnswer: {
        '@type': 'Answer',
        text: t(`faq.a${n}`),
      },
    })),
  };
  return (
    <div className="min-h-screen bg-[#FAF3EE]">
      <SEO
        title="Arts. Enrichment. Community."
        description="A community-powered space in Framingham, MA where youth, families, artists and neighbors come together to connect, create, belong and lead."
        path="/"
        jsonLd={faqJsonLd}
      />
      <Header />
      <main id="main-content">
        <Hero />
        <StorySection />
        <ImpactStats />
        <CommunityInMotion />
        <Programs />
        <Testimonials />
        <Events />
        <FAQ />
        <Contact />
        {/* Newsletter / Stay Connected hidden until an email service is chosen */}
      </main>
      <Footer />
    </div>
  );
}
